module.exports = __webpack_public_path__ + "img/Gemini.f6de7402.png";